import styled from 'styled-components';
import theme from '../theme.json';

const Wrapper = styled.div`
  background-color: ${theme.palette.light};
`;

export default Wrapper;
